import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";

const ContactPopupWidget = ({ config, handleClosePopUp }) => {
  const [options, setOptions] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [postLoading, setPostLoading] = useState(false);
  const [postSucess, setPostSucess] = useState(false);
  const [postError, setPostError] = useState(false);

  async function postMessage(conversation_id, payload) {
    try {
      const response = await axios.post(
        `/api/v1/contact-center/conversations/${conversation_id}/messages/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          xsrfCookieName: "csrftoken",
          xsrfHeaderName: "X-CSRFToken",
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  //GET /api/v1/contact-center/recipients/
  useEffect(() => {
    // Función para obtener datos del backend
    const getAvailableRecipients = async () => {
      try {
        const response = await axios.get("/api/v1/contact-center/recipients/", {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          xsrfCookieName: "csrftoken",
          xsrfHeaderName: "X-CSRFToken",
        });
        setOptions(response.data.results);
      } catch (error) {
        console.error("Error al requerir los recipients:", error);
      }
    };
    getAvailableRecipients();
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  //POST /api/v1/contact-center/conversations/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setPostLoading(true);
    const payload = {
      recipient: selectedOption,
      subject: event.target.subject.value,
    };
    try {
      const response = await axios.post(
        "/api/v1/contact-center/conversations/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
          xsrfCookieName: "csrftoken",
          xsrfHeaderName: "X-CSRFToken",
        }
      );
   
      const conversationId = response?.data.pk;
      const payloadMsg = {
        body: event.target.message.value,
      };
     
      postMessage(conversationId, payloadMsg)
        .then((data) => {
          event.target.reset();
          setSelectedOption("");
          setPostLoading(false);
          setPostSucess(true);
          setPostError(false);

        })
        .catch((error) => {
          console.log(error);
          setPostLoading(false);
          setPostSucess(false);
          setPostError(true);
        });
     
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      setPostLoading(false);
      setPostSucess(false);
      setPostError(true);
    }
  };
  return (
    <div className="SuggestionForm">
      <div className="SuggestionForm-container">
        <div className="SuggestionForm-header">
          <button
            className="SuggestionForm-closeBtn"
            onClick={handleClosePopUp}
          >
            <i className="icon-cruz"></i>
          </button>
          <h3 className="SuggestionForm-title">
            {config.translations.contactTitle}
          </h3>
        </div>
        {!postSucess ? (
          <form className="SuggestionForm-form" onSubmit={handleSubmit}>
            <label className="SuggestionForm-label" htmlFor="recipients">
              {config.translations.contactFormLabelFor}
              <select
                className="SuggestionForm-selectInput"
                id="recipients"
                value={selectedOption}
                onChange={handleOptionChange}
                required
              >
                <option value="" disabled>
                  {config.translations.contactFormLabelSelect}
                </option>
                {options?.map((option, index) => (
                  <option key={index} value={option.pk}>
                    {option.name}
                  </option>
                ))}
              </select>
            </label>
            <label className="SuggestionForm-label" htmlFor="subject">
              {config.translations.contactFormLabelSubject}
              <input
                className="SuggestionForm-textInput"
                name="subject"
                defaultValue=""
                id="subject"
                required
                maxLength="255"
                type="text"
                placeholder={config.translations.contactFormSubjectPH}
              ></input>
            </label>
            <label htmlFor="message">
              {config.translations.contactFormLabelMessage}
              <textarea
                className="SuggestionForm-areaInput"
                name="message"
                defaultValue=""
                id="message"
                required
                maxLength="255"
                placeholder={config.translations.contactFormMessagePH}
              ></textarea>
            </label>
            {postError && (
              <p className="SuggestionForm-error">
                {config.translations.contactFormError}
              </p>
            )}
            <div className="SuggestionForm-btnFooter">
              <button
                className={
                  postLoading
                    ? "SuggestionForm-submitBtn loading"
                    : "SuggestionForm-submitBtn"
                }
                type="submit"
                disabled={postLoading}
              >
                {config.translations.contactFormSubmitBtn}
              </button>
            </div>
          </form>
        ) : (
          <div className="SuggestionForm-sucess">
            <svg
              className="SuggestionForm-sucess-icon"
              xmlns="http://www.w3.org/2000/svg"
              height="48px"
              viewBox="0 -960 960 960"
              width="48px"
              fill="#e8eaed"
            >
              <path d="M480-80q-85 0-158-30.5T195-195q-54-54-84.5-127T80-480q0-84 30.5-157T195-764q54-54 127-85t158-31q75 0 140 24t117 66l-43 43q-44-35-98-54t-116-19q-145 0-242.5 97.5T140-480q0 145 97.5 242.5T480-140q145 0 242.5-97.5T820-480q0-30-4.5-58.5T802-594l46-46q16 37 24 77t8 83q0 85-31 158t-85 127q-54 54-127 84.5T480-80Zm-59-218L256-464l45-45 120 120 414-414 46 45-460 460Z" />
            </svg>
            <h4 className="SuggestionForm-sucess-msg">
              {config.translations.contactFormSucessMsg}
            </h4>
            <a
              className="SuggestionForm-submitBtn"
              href={`${window.location.origin}/${config.lang}/contact-center/`}
            >
              {config.translations.contactFormShowChatsBtn}
            </a>
            <button
              className="SuggestionForm-submitBtn"
              type="button"
              onClick={handleClosePopUp}
            >
              {config.translations.contactFormSucessBtn}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPopupWidget;
